import LocationIcon from './Icons/LocationIcon'

const Location = () => {
  return (
    <div className="location">
      <LocationIcon />
      <span className="loc_name">Буча</span>
    </div>
  )
}

export default Location
